import React, { useState } from 'react';
import { StaticImage } from 'gatsby-plugin-image';

import { useContactDetails, useNavigationItems } from '@hooks';
import type { TLinkTree } from '@hooks';

import { NavigationContainer, SubnavigationContainer } from './styles';
import { ConstLink } from '../const-link';

interface ISubnavigation {
  links?: TLinkTree[];
}

// @TODO: Figure out a nice pattern of recursion if we need it.
const SubNavigation = ({ links }: ISubnavigation) => {
  if (!links) {
    return null;
  }

  return (
    <SubnavigationContainer className="subnavigation__container">
      {links.map(({ href, innerText }) => (
        <ConstLink className="navigation__link" to={href} key={innerText}>
          {innerText}
        </ConstLink>
      ))}
    </SubnavigationContainer>
  );
};

const Navigation = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigation = useNavigationItems('header');
  const { phone } = useContactDetails();

  const phoneHref = `tel:${phone.trim().replaceAll(' ', '')}`;

  // @TODO - find nearest instance of submission form on page and scroll
  // to that

  return (
    <NavigationContainer className="navigation">
      <div className="navigation__row">
        <ConstLink
          className="navigation__logo"
          to="/"
          title="Return to Accident Legal homepage"
        >
          <StaticImage
            src="../../images/al-logo-better-days.png"
            alt="Accident Legal™ - Better days ahead"
          />
        </ConstLink>
        <a
          role="button"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          className={[
            'navigation__mobile',
            isMobileMenuOpen ? 'navigation__mobile--open' : null,
          ].join(' ')}
          title={`${isMobileMenuOpen ? 'Close' : 'Open'} menu`}
        >
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </a>
        <div
          className={[
            'navigation__links',
            isMobileMenuOpen ? 'navigation__links--open' : null,
          ].join(' ')}
        >
          {navigation.map(({ href, innerText, subNavigation }) => {
            if (!subNavigation || subNavigation.length === 0) {
              return (
                <ConstLink
                  className="navigation__link"
                  to={href}
                  key={innerText}
                >
                  {innerText}
                </ConstLink>
              );
            }

            return (
              <div className="navigation__link_wrapper" key={innerText}>
                <ConstLink
                  className="navigation__link"
                  to={href}
                  key={innerText}
                >
                  {innerText}{' '}
                  <span className="navigation__link_expand">&rsaquo;</span>
                </ConstLink>
                <SubNavigation links={subNavigation} />
              </div>
            );
          })}
        </div>
        <div className="navigation__cta">
          <ConstLink to="/contact-us">Get in touch</ConstLink>
          <a href={phoneHref}>{phone}</a>
        </div>
      </div>
    </NavigationContainer>
  );
};

export { Navigation };
